import React from "react";
import {ToastContainer} from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import CONFIG from "./toaster.config";

/** This component will render ToastContainer component of react-toastify library.
 * with configuration defined for this project.
 *
 * This component will be imported only once at the top level of application.
 * and we just use methods provide by react-toastify to trigger toaster display
 */

function Toaster() {
  return <ToastContainer {...CONFIG} />;
}

export default Toaster;
